export const logo = '/images/logo.svg';
export const placeholder = '/images/placeholder.svg';
export const placeholderSquare = '/images/placeholder-square.svg';
export const heroBg = '/images/hero-bg.jpg';
